import './step-slider.scss';

import { A11y, Navigation } from 'swiper/modules';

class StepSlider {
    constructor ($element, options) {
        const defaults = {
            initAttr: 'data-stepslider',
            gridAttr: 'data-stepslider-grid'
        };

        this.settings = Object.assign({}, defaults, options);
        this.$stepSlider = $element;
        this.$stepSliderSlides = this.$stepSlider.querySelectorAll('[' + this.settings.initAttr + '="slide"]');
        this.stepSlider = null;
        this.stepSliderGrid = false;

        if (this.$stepSlider.hasAttribute(this.settings.gridAttr)) {
            this.stepSliderGrid = true;
        }

        this.resizeHandler = window.resizeHandler;
        this.sliderActive = false;

        if (this.$stepSliderSlides.length > 1) {
            import(
                /* webpackChunkName: "slider/slider.js" */
                './../../components/slider/slider').then(({ Slider }) => {
                this.Slider = Slider;
                this.initialize();
            });
        }
        // this.initialize();
    }

    initialize () {
        this.checkSize();
        this.resizeHandler.customFunctions.push(() => {
            this.checkSize();
        });
    }

    checkSize () {
        if (window.innerWidth < 768 && this.$stepSliderSlides.length > 1) {
            if (this.sliderActive === false) {
                this.initSlider();
            }
        } else if (window.innerWidth < 1024 && this.$stepSliderSlides.length > 3 && this.stepSliderGrid === false) {
            if (this.sliderActive === false) {
                this.initSlider();
            }
        } else if (window.innerWidth >= 1024 && this.$stepSliderSlides.length > 4 && this.stepSliderGrid === false) {
            if (this.sliderActive === false) {
                this.initSlider();
            }
        } else {
            if (this.sliderActive === true) {
                this.destroySlider();
                this.sliderActive = false;
            }
        }
    }

    initSlider () {
        this.stepSlider = new this.Slider(this.$stepSlider, {
            modules: [A11y, Navigation],
            speed: 500,
            slidesPerView: 'auto',
            centeredSlides: true,
            centeredSlidesBounds: true,
            initAttr: this.settings.initAttr,
            centerInsufficientSlides: true
        });

        this.sliderActive = true;
    }

    destroySlider () {
        if (typeof this.stepSlider !== 'undefined' && this.stepSlider !== null) {
            this.stepSlider.destroy();
        }
    }
}

export { StepSlider };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$stepSlider = $context.querySelectorAll('[data-stepslider="root"]');
        for (let i = 0; i < $$stepSlider.length; i++) {
            const $stepSlider = $$stepSlider[i];

            const stepSliderAPI = new StepSlider($stepSlider);
            $stepSlider.API = stepSliderAPI;
        }
    }
});
